import React from 'react';
import { keyBoardAccessibilityAttributes } from '../../../../../utils/GeneralUtils';

const ConfettiModalContent = ({ modalContent, onClose }) => {
  const modalBody = modalContent.modal.body;
  const bodyActions = modalBody.actions;
  const joinInfo = modalBody.joinInfo;

  return(
    <>
      <div className='clearfix'>
        <i className='float-right fa-regular fa-xmark' onClick={ onClose } { ...keyBoardAccessibilityAttributes } />
      </div>

      <div className="media">
        <img src={ modalBody.image.url } alt={ modalBody.image.alt } height='150' width='150' />
        <div className="media-body ml-4">
          <div className='font-16 font-bold '> { modalBody.heading } </div>
          <div className='mt-2' dangerouslySetInnerHTML={{ __html: modalBody.content }} />
          {
            bodyActions && <div className='mt-3'>
              {
                bodyActions.viewEvent && <>
                  <a
                    className='btn btn-primary btn-rounded-5 mr-3'
                    target='_blank'
                    href={ bodyActions.viewEvent.url }
                    { ...keyBoardAccessibilityAttributes }
                  >
                    <i className='fa-regular fa-calendar mr-2'/>
                    { bodyActions.viewEvent.name }
                  </a>
                  { bodyActions.shareEvent && <div className='d-xs-none mt-2' /> }
                </>
              }
              {
                bodyActions.shareEvent && <>
                  <div id='cjs-share-event-link' className="cui-hide-using-position">
                    { bodyActions.shareEvent.url }
                  </div>
                  <div className='btn btn-primary btn-outline btn-rounded-5' data-clipboard-target='#cjs-share-event-link' { ...keyBoardAccessibilityAttributes }>
                    <i className='fa-regular fa-copy mr-2'/>
                    { bodyActions.shareEvent.name }
                  </div>
                </>
              }
            </div>
          }
        </div>
      </div>

      {
        joinInfo && <div className='cui-border-radius-6 gray-bg p-3 mt-3 align-items-center clearfix row mx-0 font-bold text-primary border'>
          <div className='col-10 p-0' dangerouslySetInnerHTML={{ __html: joinInfo.prefix }}/>
          <a className='btn btn-primary btn-sm btn-rounded-5 ml-auto' href={ joinInfo.url } { ...keyBoardAccessibilityAttributes } target='_blank'>
            { joinInfo.name }
          </a>
        </div>
      }
    </>
  )
}

export default ConfettiModalContent;